import { ChangelogCsvUploadWizard } from "./changelog-csv-upload-wizard"

export function ChangelogCsvUploadField() {
	return (
		<>
			<div>
				<header className="space-y-1 text-sm">
					<div className="text-base font-medium">File upload</div>
					<div className="mb-6 text-secondary">
						Import Changelogs from a CSV file
					</div>
				</header>
				<div className="mt-4 overflow-hidden">
					<ChangelogCsvUploadWizard />
				</div>
			</div>
		</>
	)
}
